package games.polyclub.website.frontend.store.components

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.*
import games.polyclub.frontend.lib.react.utils.useEffectOnceAsync
import games.polyclub.service.payment.api.id.ProductId
import games.polyclub.tool.functional.retrying
import games.polyclub.website.frontend.store.StoreBff
import games.polyclub.website.frontend.store.appScope
import react.Props
import react.useState

external interface ProductNameProps : Props {
    @Suppress("INLINE_CLASS_IN_EXTERNAL_DECLARATION_WARNING")
    var productId: ProductId
}

val ProductName = SFC<ProductNameProps> { props ->
    val (productName, setProductName) = useState<String?>(null)

    appScope.useEffectOnceAsync {
        setProductName(retrying {
            StoreBff.productName(props.productId)
        })
    }

    if (productName != null) {
        +productName
    } else {
        em {
            +props.productId.toString()
        }
    }
}
